module.exports = __webpack_public_path__ + "videos/nft.88031ce.webm";